/**
 * 全局指令
 * */

export default {
  /**
   * 默认图片指令 (当元素error的时候 把该元素的src属性设置为默认值 (变量值 || 字符串 || 默认头像);
   * */
  'df-avatar': {
    bind(el, {value, expression}) {
      let src = value || expression || require('../assets/images/header/home_default_head.png');
      el.src += '';
      el.addEventListener('error', () => {
        el.src !== src && el.src !== location.origin + src && (el.src = src);
      });
    },
  },
  /**
   * 默认课程底图 ([Object | String] value 变量值)
   */
  'df-base': {
    bind(el, {value, expression}) {
      let base_obj = typeof value === 'object' ? value : {url: value};
      let url = base_obj.url || require('../assets/images/base_bg.png');
      let bg = `url(${url}) no-repeat center center / ${base_obj.width || 149}px`;
      el.style.background = bg;
      el.addEventListener('load', () => {
        el.style.background = "none";
      });
      el.addEventListener('error', () => {
        el.style.background = bg;
      });
    },
  },
}